import { PropsWithChildren, createContext, useContext, useMemo } from 'react'

import { FetchSidebarFavoritesQuery } from 'generated/resources/graphql'

export type Favorite = FetchSidebarFavoritesQuery['layout']['favouritesConnection']['edges'][number]['node']

export type FavoritesProviderProps = PropsWithChildren<{
  favorites: Favorite[]
}>

export type FavoriteContextValue = {
  idByUrl: Record<string, string>
  raw: FavoritesProviderProps['favorites']
}

const FavoritesContext = createContext<FavoriteContextValue>({ raw: [], idByUrl: {} })

export const SidebarFavoritesProvider = ({ favorites = [], children }: FavoritesProviderProps) => {
  const value = useMemo(() => {
    return {
      idByUrl: favorites.reduce<FavoriteContextValue['idByUrl']>((acc, cur) => {
        acc[cur.url] = cur.id
        return acc
      }, {}),
      raw: favorites,
    }
  }, [favorites])

  return <FavoritesContext.Provider value={value}>{children}</FavoritesContext.Provider>
}

export const useSidebarFavorites = () => {
  return useContext(FavoritesContext)
}
